import React from 'react';

import './style.scss';

class Card extends React.Component {
  render() {
    return <div className="card__background">{this.props.children}</div>;
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/Card/index.js